<template>
  <Modal
    v-model="state"
    :title="plustitle"
    width="840"
    :mask-closable="false"
    class-name="vertical-center-modal"
    @on-visible-change="bindGetData"
  >
    <p slot="header">
      <span>{{ plustitle }}</span>
      <span style="float: right; margin: 1px 30px 0 0">剩余分配比例：{{ restRatio }} %</span>
    </p>
    <Form :label-width="55" class="formbox" inline>
      <FormItem label="月份">
        <!-- :options="datetimeOption" -->
        <DatePicker
          type="month"
          v-model="recordInfo.tdateMonth"
          placeholder="请选择"
          :disabled="edit"
          editable
          transfer
          style="width: 100px"
          @on-change="setMonth"
        >
        </DatePicker>
      </FormItem>
      <FormItem label="平台">
        <auto-complete
          v-model="recordInfo.platform"
          :data="platformData"
          :disabled="edit"
          :popper-append-to-body="false"
          placeholder="全部"
          style="width: 120px"
          @on-select="handlePlatform"
        ></auto-complete>
      </FormItem>
      <FormItem label="游戏">
        <auto-complete
          v-model="recordInfo.gameId"
          :data="gameDataFiltered"
          :disabled="edit || !recordInfo.platform"
          :popper-append-to-body="false"
          placeholder="全部"
          style="width: 120px"
          @on-select="handleGame"
        ></auto-complete>
      </FormItem>
      <FormItem label="30日充值金额：" :label-width="120" v-if="recordInfo">
        <template v-if="recordInfo.platform">
          <span v-if="recordInfo.platform === 2">{{ recordInfo.thirtyMoneyNum }}</span>
          <input-number-plus
            v-else
            v-model="recordInfo.thirtyMoneyNum"
            :max="9"
            :min="0"
            :precision="2"
            :width="100"
            placeholder="请输入"
          />
        </template>
      </FormItem>
      <div v-for="(item, index) in recordList" :key="index">
        <FormItem label="人员">
          <auto-complete
            v-model="item.opId"
            :data="peopleData"
            :popper-append-to-body="false"
            placeholder="全部"
            style="width: 100px"
            @on-select="handlePeople($event, index)"
          ></auto-complete>
        </FormItem>
        <FormItem label="媒体">
          <auto-complete
            :data="medias"
            :popper-append-to-body="false"
            v-model="item.mediaId"
            placeholder="全部"
            style="width: 120px"
            @on-select="handleMedia($event, index)"
          ></auto-complete>
        </FormItem>
        <FormItem label="比例" :label-width="50">
          <input-number-plus
            v-model="item.ratio"
            :maxNum="100"
            :max="3"
            :min="0.01"
            :precision="2"
            :width="100"
            @on-blur="ratioBlur(index)"
            placeholder="请输入"
          />
          <span class="c-unit"> %</span>
        </FormItem>
        <span class="ratioNum">{{ (item.ratio * thirtyMoney * 0.01).toFixed(2) }}</span>
        <Icon type="ios-trash" class="trashIcon" @click="handleDelete(index)" v-if="recordInfo.launchOps.length > 1" />
      </div>
      <br />
      <FormItem :label-width="15">
        <Button @click="handleAdd" icon="md-add" style="color: rgb(45, 140, 240); border: 1px solid rgb(45, 140, 240)">添加人员</Button>
      </FormItem>
    </Form>
    <template slot="footer">
      <div class="m-foot">
        <Button @click="$emit('input', false)">取消</Button>
        <Button type="primary" :loading="loading" @click="$emit('on-save', recordInfo)">
          <span v-if="loading">提交中...</span>
          <span v-else>确认</span>
        </Button>
      </div>
    </template>
  </Modal>
</template>
<script>
import { mul, div } from '@/common/js/api'
import { getThirtyMoney, isIosRechargeExist } from '@/api/manage.model'
import { formatDate, isEmpty, isArray } from '@/common/js/utils'
import AutoComplete from '@/components/autocomplete/autocomplete'
import InputNumberPlus from '@/components/input/input-number-plus'
export default {
  name: 'setRecord',
  components: { AutoComplete, InputNumberPlus },
  props: {
    value: {
      type: Boolean
    },
    title: {
      type: String
    },
    loading: {
      type: Boolean,
      default() {
        return false
      }
    },
    info: {
      type: Object
    },
    edit: {
      type: Boolean,
      default() {
        return false
      }
    },
    gameData: {
      type: Array,
      default() {
        return []
      }
    },
    medias: {
      type: Array,
      default() {
        return []
      }
    },
    peopleData: {
      type: Array,
      default() {
        return []
      }
    }
  },
  computed: {
    state: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    property() {
      return (val) => val !== undefined
    },
    plustitle() {
      return `${this.edit ? '修改' : '新增'}${this.title}`
    },
    thirtyMoney() {
      return this.recordInfo.thirtyMoneyNum
    },
    restRatio() {
      const num = (
        100 -
        (isArray(this.recordInfo.launchOps) &&
          this.recordInfo.launchOps.reduce((acc, cur) => {
            return acc + (cur.ratio ? cur.ratio : 0)
          }, 0))
      ).toFixed(2)
      return num.toString() === '-0.00' ? '0.00' : num
    },
    recordList() {
      return this.recordInfo.launchOps
    },
    gameDataFiltered() {
      if (this.recordInfo.platform) return this.gameData.filter((ret) => ret.ch_platform_id === this.recordInfo.platform)
      else return this.gameData
    }
  },
  watch: {
    info: {
      handler(nVal) {
        this.updateInfo()
      },
      deep: true
    }
  },
  methods: {
    updateInfo() {
      const info = Object.assign({}, this.info, {
        platform: this.info.platform ? this.info.platform : '',
        gameId: this.info.gameId ? this.info.gameId : '',
        tdateMonth: this.info.tdateMonth ? formatDate(new Date(this.info.tdateMonth), 'yyyy-MM') : '',
        launchOps: this.info.launchOps ? this.info.launchOps : [],
        thirtyMoneyNum: this.info.thirtyMoney || this.info.thirtyMoney === 0 ? this.info.thirtyMoney : ''
      })
      this.$set(this, 'recordInfo', info)
    },
    setMonth(val) {
      this.recordInfo.tdateMonth = val
      const { gameId, tdateMonth, platform } = this.recordInfo
      if (gameId && tdateMonth && platform === 2) this.setThirtyMoney(gameId, tdateMonth)
    },
    handleGame(meta) {
      this.recordInfo.gameId = meta.id
      const { gameId, tdateMonth, platform } = this.recordInfo
      if (gameId && tdateMonth && platform === 2) this.setThirtyMoney(gameId, tdateMonth)
    },
    handlePlatform(meta) {
      this.recordInfo.platform = meta.id
      this.recordInfo.gameId = ''
    },
    handleMedia(meta, index) {
      this.recordInfo.launchOps[index].mediaId = meta.id
    },
    handlePeople(meta, index) {
      this.recordInfo.launchOps[index].opId = meta.id
    },
    setThirtyMoney(gameId, tdateMonth) {
      getThirtyMoney({
        tdateMonth,
        gameId
      })
        .then((data) => {
          this.$set(this.recordInfo, 'thirtyMoneyNum', data)
        })
        .catch((err) => {
          this.$Message.error({
            duration: 5,
            content: err
          })
        })
    },
    toFloat(key, obj, fixed) {
      if (isEmpty(obj[key])) return
      let val = parseFloat(obj[key])
      if (isNaN(val)) val = ''
      else if (val < 0) val = 0
      else if (fixed) {
        val = mul(val, 100)
        val = div(Math.floor(val), 100)
      }
      obj[key] = val
      this.$forceUpdate()
    },
    handleAdd() {
      const { gameId, tdateMonth } = this.recordInfo
      if (this.recordInfo.launchOps.length === 99) {
        // 人员添加上限99
        this.$Message.error({
          duration: 5,
          content: '已到达人员添加上限！'
        })
      } else if (this.recordInfo.tdateMonth && this.recordInfo.gameId) {
        if (this.recordInfo.launchOps.length === 0) {
          isIosRechargeExist({
            tdateMonth,
            gameId
          })
            .then((data) => {
              if (data) {
                this.$Message.error({
                  duration: 5,
                  content: '已存在相同的月份与游戏'
                })
              } else {
                this.recordInfo.launchOps.push({
                  opId: '',
                  mediaId: '',
                  ratio: ''
                })
              }
            })
            .catch((err) => {
              this.$Message.error({
                duration: 5,
                content: err
              })
            })
        } else {
          this.recordInfo.launchOps.push({
            opId: '',
            mediaId: '',
            ratio: ''
          })
        }
      } else {
        this.$Message.error({
          duration: 5,
          content: '请选择月份与游戏!'
        })
      }
    },
    handleDelete(index) {
      this.recordInfo.launchOps.splice(index, 1)
    },
    ratioBlur(index) {
      if (this.restRatio < 0) {
        this.$Message.error({
          duration: 5,
          content: '分配比例总和不能大于100!'
        })
        setTimeout(() => {
          this.$set(this.recordInfo.launchOps[index], 'ratio', '')
        }, 100)
      }
    },
    bindGetData() {
      if (!this.edit) {
        this.recordInfo = {
          platform: '',
          gameId: '',
          tdateMonth: '',
          thirtyMoneyNum: '',
          launchOps: []
        }
      }
    }
  },
  data() {
    return {
      platformData: [
        { id: 1, name: '安卓' },
        { id: 2, name: 'iOS' },
        { id: 3, name: '小程序' }
      ],
      recordInfo: {},
      thirtyMoneyNum: '',
      datetimeOption: {
        disabledDate(date) {
          return date && date.valueOf() > Date.now()
        }
      }
    }
  },
  created() {
    // this.proloadData()
  },
  mounted() {
    this.$nextTick(() => {
      this.updateInfo()
    })
  }
}
</script>
<style lang="scss" scoped>
.formbox {
  max-height: 400px;
  overflow-y: scroll;
}

.c-unit {
  padding-left: 8px;
}

.trashIcon {
  font-size: 25px;
  margin: 0 0px 2px 4px;
  cursor: pointer;
  transition: 0.3s all;

  &:hover {
    color: rgb(45, 140, 240);
  }
}

.ratioNum {
  display: inline-block;
  margin: 7px 0 0 0;
}
</style>
